export default function CenterCardRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    #market-rules-text ol {
                        list-style-type: decimal;
                        padding-left: 40px;
                    }
                    #market-rules-text ol li {
                        list-style: list-item !important;
                    }
                `}
            </style>

            <div class="modal fade show" style={{ display: "block", paddingLeft: "0px", marginBottom: "20px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>Center Card</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">To predict whether the Center card drawn is between Left card and Right card drawn.</p>
                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20"><b> Hands Dealt:</b> 1 (Left card, Right card &amp; Center card)</p>
                                            <p class="pt20"><b>Bets:</b>:Dealer Draws the Left card first and then the Right card.</p>
                                            <p class="pt20"><b>Center Yes wins: </b>:  If Center card rank is in between the Left and Right card ranks.</p>
                                            <p class="pt20">
                                                <b>Center No wins :</b>
                                                If Center card rank not in between the the Left and Right card ranks.
                                            </p>
                                            <p class="pt20"><b>Note : </b> If the Center card rank is same as either the Left or Right card then Center Yes Wins.</p>
                                            <p class="pt20">
                                                <b>Number Ranking:</b>
                                                Lowest to highest: Ace, 2, 3, 4, 5, 6, 7,8, 9, 10, Jack, Queen, King (Ace is "1" and King is "13".)
                                            </p>
                                        </div>

                                        <div>
                                            <div>
                                                <center><h3>PAYOUTS</h3></center>
                                                <div>
                                                    <p class="pt20">Payout as per the bet placed. </p>
                                                    <table class="table table-bordered table-sm">
                                                        <tbody>
                                                            <tr>
                                                                <th>Yes</th>
                                                                <th>
                                                                    1 to 1.5
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th>No</th>
                                                                <th>
                                                                    1 to 0.6
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>Even</th>
                                                                <th>
                                                                    1 to 1.1
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>Odd</th>
                                                                <th>
                                                                    1 to 0.8
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>Red/Black</th>
                                                                <th>
                                                                    1 to 0.98
                                                                </th>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </center>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}